import { useNavigate } from "react-router";

import {
  Container,
  IconContainer,
  CardInfosContainer,
  CardTitle,
  CardDescription,
  NextText,
  Separator,
} from "./styles";
import Logo from "../../assets/symbol-purple_animation.svg";
import { i18n } from "../../localization/i18n";
import { LockedFeatureIcon } from "../LockedFeatureIcon";

interface HomeCardProps {
  title: string;
  icon: any;
  description: string;
  pageRoute: string;
  disabled?: boolean;
  isLocked?: boolean;
}

export function HomeCard({
  title,
  icon,
  description,
  pageRoute,
  disabled,
  isLocked = false,
}: HomeCardProps) {
  const navigate = useNavigate();

  return (
    <Container
      onClick={() => !disabled && !isLocked && navigate(pageRoute)}
      disabled={disabled}
      $isLocked={isLocked}
    >
      {isLocked && <LockedFeatureIcon withOverlay />}

      <IconContainer $isLocked={isLocked}>
        {
          process.env.NODE_ENV === 'development' ? 
            (<img alt="HomeCard img" src={icon ?
              `${process.env.REACT_APP_STORAGE_BASE_URL}${icon}` :
              Logo} />) :
              (
                <embed src={
                  icon ?
                    `${process.env.REACT_APP_STORAGE_BASE_URL}${icon}` :
                    Logo
                  } />
              )
        }
      </IconContainer>

      <Separator $isLocked={isLocked} />

      <CardInfosContainer $isLocked={isLocked}>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>

        <NextText>{`${i18n.t("orders.clickToProceed")}` + ">"}</NextText>
      </CardInfosContainer>
    </Container>
  );
}
